import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";

import useSubscriptionInfo from "../../hooks/useSubscriptionInfo";
import { AddUserContainer, ContainerVariant } from "../AddUserContainer";
import { Information, InformationButtons } from "./components";

export function SubscriptionInformationPage({
  title,
  inviteCount,
  loading,
  toPrev,
  containerVariant,
  cancelButton,
  agreeButtonText,
  onClose,
  onSubmit,
  onScheduledChangesAtDetected,
  ...props
}) {
  const {
    loading: loadingSubscriptions,
    error,
    subscriptionInfo,
  } = useSubscriptionInfo(inviteCount);

  const agreeTitle = useMemo(() => {
    if (agreeButtonText) return agreeButtonText;

    return subscriptionInfo?.before.deltaSeats ||
      subscriptionInfo?.renewal?.deltaSeats
      ? "Agree"
      : "Finish";
  }, [agreeButtonText, subscriptionInfo]);

  useEffect(() => {
    if (subscriptionInfo?.scheduledChangesAt) {
      onScheduledChangesAtDetected(subscriptionInfo.scheduledChangesAt);
    }
  }, [subscriptionInfo, onScheduledChangesAtDetected]);

  return (
    <React.Fragment>
      <AddUserContainer.Header variant={containerVariant} onClose={onClose}>
        {title}
      </AddUserContainer.Header>

      <AddUserContainer.Body variant={containerVariant} scrolling>
        {error ? (
          <p>{error}</p>
        ) : (
          <Information
            loading={loadingSubscriptions}
            subscriptionInfo={subscriptionInfo}
            {...props}
          />
        )}
      </AddUserContainer.Body>

      <AddUserContainer.Footer variant={containerVariant}>
        <InformationButtons
          title={agreeTitle}
          agreeButtonText={agreeButtonText}
          cancelButton={cancelButton}
          disabled={loading || loadingSubscriptions}
          loading={loading || loadingSubscriptions}
          toPrev={toPrev}
          onClose={onClose}
          onSubmit={() => {
            onSubmit();
          }}
        />
      </AddUserContainer.Footer>
    </React.Fragment>
  );
}

SubscriptionInformationPage.propTypes = {
  inviteCount: PropTypes.number,
  loading: PropTypes.bool,
  toPrev: PropTypes.func,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  onScheduledChangesAtDetected: PropTypes.func,
  containerVariant: PropTypes.oneOf(Object.values(ContainerVariant)),
  cancelButton: PropTypes.node,
  agreeButtonText: PropTypes.node,
  title: PropTypes.string,
};

SubscriptionInformationPage.defaultProps = {
  inviteCount: 0,
  loading: false,
  toPrev: null,
  onSubmit: () => {},
  onClose: () => {},
  onScheduledChangesAtDetected: () => {},
  containerVariant: ContainerVariant.MODAL,
  cancelButton: undefined,
  agreeButtonText: undefined,
  title: "Changes Overview",
};

export default SubscriptionInformationPage;
